import React from 'react';

const ProfileQuestionContext = React.createContext({
    allQuestions: [],
    questions: [],
    setQuestions: (e) => {},
    org: null,
    setOrg: (e) => {},
    orgList: [],
    setOrgList: (e) => {},
    questionGroups: [],
    setQuestionGroups: (e) => {},
    questionGroup: null,
    setQuestionGroup: (e) => {},
    questionDialogOpen: false,
    setQuestionDialogOpen: (e) => {},
    editQuestionData: null,
    setEditQuestionData: (e) => {},
    requiredQuestions: [],
    setRequiredQuestions: (e) => {},
    questionGroupMessage: '',
    setQuestionGroupMessage: (e) => {}
});

export default ProfileQuestionContext;